/* beautiful-react-hooks version: 0.35.0 */
var getPointerCoordinates = function getPointerCoordinates(event) {
  if (event.touches) {
    var _event$touches$ = event.touches[0],
        _clientX = _event$touches$.clientX,
        _clientY = _event$touches$.clientY;
    return [_clientX, _clientY];
  }

  var clientX = event.clientX,
      clientY = event.clientY;
  return [clientX, clientY];
};
var getHorizontalDirection = function getHorizontalDirection(alpha) {
  return alpha < 0 ? 'right' : 'left';
};
var getVerticalDirection = function getVerticalDirection(alpha) {
  return alpha < 0 ? 'down' : 'up';
};
var getDirection = function getDirection(currentPoint, startingPoint, alpha) {
  var alphaX = startingPoint[0] - currentPoint[0];
  var alphaY = startingPoint[1] - currentPoint[1];

  if (Math.abs(alphaX) > Math.abs(alphaY)) {
    return getHorizontalDirection(alpha[0]);
  }

  return getVerticalDirection(alpha[1]);
};

export { getDirection, getHorizontalDirection, getPointerCoordinates, getVerticalDirection };
